import { render, staticRenderFns } from "./text-status.vue?vue&type=template&id=600914fc&scoped=true"
var script = {}
import style0 from "./text-status.vue?vue&type=style&index=0&id=600914fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600914fc",
  null
  
)

export default component.exports